import {installScrollRestoration, useScrollRestoration} from '../use-scroll-restoration'

installScrollRestoration()

export function ScrollRestoration() {
  useScrollRestoration()

  return null
}

try{ ScrollRestoration.displayName ||= 'ScrollRestoration' } catch {}